"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslateMixin = void 0;
const i18n_1 = require("../directives/i18n");
exports.TranslateMixin = {
    'name': 'TranslateMixin',
    'methods': {
        $t(englishString) {
            return i18n_1.$t(englishString);
        },
    },
};
//# sourceMappingURL=TranslateMixin.js.map